import React, {
    useCallback, useState, useEffect, useRef,
} from 'react';
import PropTypes, { func } from 'prop-types';
import classNames from 'classnames';
import {
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    useLocation,
} from 'react-router-dom';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect, ReactReduxContext, useSelector } from 'react-redux';
import Observer from 'react-intersection-observer';
import Cookies from 'universal-cookie';
import Typography from '../Typography/CustomTypography';
import { OBJ_LANGUAGE, Role } from '../../common/Constants';
import { LogoutRequested } from '../../actions/Auth';
import { ClearGetDetailCompanyOrganizerForSideBar, GetDetailCompanyOrganizerForSideBarRequested } from '../../actions/CompanyManagementOrganizer';
import {
    LogOutIcon, SurveyIcon, LanguageIcon, ArrowDown, NextIcon,
} from '../Icons/Icon';
import styles from '../../assets/jss/components/userSideBarStyle';
import FormDialog from '../Dialog/FormDialog';
import Advertisement from '../Advertisement/Advertisement';
import Button from '../Button/CustomButton';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import { getCountProductRequested, clearCountProduct } from '../../actions/CartViewer';
import { getSettingCustomTextRequested, getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear } from '../../actions/AdminSettingCustom';
import { isAfterEnd30Day, isBeforeStart14Day, isBeforeUsingStartXdays, isAfterUsingEndXdays } from '../../utils/dateUtils';
import UserSideBarCustomLayoutFirst from './UserSideBarCustomLayoutFirst';
import {
    changeLanguageActions,
    changeLanguageOtherActions,
    changeLanguageOtherInit,
    updateLanguageRequest,
} from '../../actions/Locale';
import { callApiGetInformationXPAND, clearGetInfomationData } from '../../actions/RegistrationViewer';

const useStyles = makeStyles(styles);

const UserSideBar = (props) => {
    const classes = useStyles(props);
    const {
        color,
        image,
        eventInfo,
        routes,
        logOut,
        isAuthorized,
        isWeakAuth,
        viewerType,
        viewerLiveStream,
        isUser,
        role,
        isOpenToggle,
        handleDrawerToggle,
        fetchClearGetDetailCompanyOrganizerForSideBar,
        dataAuthorized,
        getDetailCompanyForSideBar,
        eventCurrent,
        getCount,
        clearCount,
        countProduct,
        loginOuterServer,
        getCustomText,
        customColorSidebar,

          /*  ★★ */
        customTimerctrl,
        getSettingCustomTimerctrl,
        clearGetSettingCustomTimerctrl,

        changeLanguage,
        updateLanguage,
        locale,
        fetchInfo,
        langChange,
        changeLangOther,
        changeLangInit,
    } = props;

    const match = useRouteMatch();
    const intl = useIntl();
    const params = useParams();
    const history = useHistory();
    const location = useLocation();
    const cookies = new Cookies();
    const [listRoutes, setListRoutes] = useState([]);
    const [isOpenEndDialog, setIsOpenEndDialog] = useState(false);
    const [classFixed, setClassFixed] = useState('');
    const [countCart, setCountCart] = useState(0);
    const [colorOrganizer, setColorOrganizer] = useState(false);
    const [language, setLanguage] = useState('日本語');
    const [isOpenTranslate, setIsOpenTranslate] = useState(false);
    const [screenSize, setScreenSize] = useState(false);
    const [isGoogleTrans, setIsGoogleTrans] = useState(false);

    const activeRoute = useCallback((routeName) => match.path.indexOf(routeName) > -1, [match]);
    const showGoogle = sessionStorage.getItem('objLang');

    const JMB_timeSetData=useSelector(state=>state.adminSettingCustom?.getCustomTimerctrl?.data )
    let JMB_TC_exhlist_before=undefined;
    let JMB_TC_exhprod_after=undefined;
    let JMB_TC_smn_after=undefined;
    let JMB_TC_smn_before=undefined;
    let JMB_TC_live_after=undefined;
    let JMB_TC_live_before=undefined;
    let JMB_TC_smnord_after=undefined;
    let JMB_TC_smnord_before=undefined;
    
    if(JMB_timeSetData?.TC_exhlist_before){
        JMB_TC_exhlist_before=JMB_timeSetData?.TC_exhlist_before;
    //    console.log( "OK , found out... UserSideBar L123 TC_exhlist_before  is ," + JMB_TC_exhlist_before  );
    }
    if(JMB_timeSetData?.TC_exhprod_after){
        JMB_TC_exhprod_after=JMB_timeSetData?.TC_exhprod_after;
    //    console.log( "OK , found out... UserSideBar L128 TC_exhprod_after  is ," + JMB_TC_exhprod_after  );
    }
    if(JMB_timeSetData?.TC_smn_after){
        JMB_TC_smn_after=JMB_timeSetData?.TC_smn_after;
    //    console.log( "OK , found out... UserSideBar L132 TC_smn_after  is ," + JMB_TC_smn_after  );
    }
    if(JMB_timeSetData?.TC_smn_before){
        JMB_TC_smn_before=JMB_timeSetData?.TC_smn_before;
    //    console.log( "OK , found out... UserSideBar L136 TC_smn_before  is ," + JMB_TC_smn_before  );
    }
    if(JMB_timeSetData?.TC_live_after){
        JMB_TC_live_after=JMB_timeSetData?.TC_live_after;
    //    console.log( "OK , found out... UserSideBar L140 TC_live_after  is ," + JMB_TC_live_after  );
    }
    if(JMB_timeSetData?.TC_live_before){
        JMB_TC_live_before=JMB_timeSetData?.TC_live_before;
    //    console.log( "OK , found out... UserSideBar L144 TC_live_before  is ," + JMB_TC_live_before  );
    }
    if(JMB_timeSetData?.TC_smnord_after){
        JMB_TC_smnord_after=JMB_timeSetData?.TC_smnord_after;
    //    console.log( "OK , found out... UserSideBar L148 TC_smnord_after  is ," + JMB_TC_smnord_after );
    }
    if(JMB_timeSetData?.TC_smnord_before){
        JMB_TC_smnord_before=JMB_timeSetData?.TC_smnord_before;
    //    console.log( "OK , found out... UserSideBar L152 TC_smnord_before  is ," + JMB_TC_smnord_before );
    }

    const handleResize = () => {
        if (window.innerWidth < 960) {
            setScreenSize(true);
        } else {
            setScreenSize(false);
        }
    };

    useEffect(() => {
        if (params.shortName !== cookies.get('osesen') && !_.isUndefined(cookies.get('osesen')) && params.shortName) {
            logOut();
            history.push(`/${params.shortName}/home`);
        }
    }, [params.shortName, eventCurrent]);

    useEffect(() => {
        // shit code
        let temp = routes;

        if (!eventInfo.has_exhibition || !eventInfo.display_exhibition) {
            const exhibitionRoutes = [
                '/exhibitors',
                '/exhibitor-posters',
            ];
            temp = temp.filter((route) => !exhibitionRoutes.includes(route.path));
        }

        if (!eventInfo.has_live_stream || !eventInfo.display_live_stream) {
            const liveStreamRoutes = [
                '/live_stream',
                '/live-stream-registered',
            ];
            temp = temp.filter((route) => !liveStreamRoutes.includes(route.path));
        }

        if (!eventInfo.has_seminar || !eventInfo.display_seminar) {
            const seminarRoutes = [
                '/list-seminar',
                '/seminars',
                '/seminar_registered',
            ];
            temp = temp.filter((route) => !seminarRoutes.includes(route.path));
        }

        if (!isAuthorized) {
            const noLogin = [
                '/seminar_registered',
                '/live-stream-registered',
                '/exhibitor-posters',
            ];
            temp = temp.filter((route) => !noLogin.includes(route.path));
        }

        if (isWeakAuth || isWeakAuth === 'true') {
            const ignoreRouterFreeLogin = [
                '/exhibitor-posters',
                '/seminar_registered',
                '/live-stream-registered',
            ];
            if (!eventInfo.free_seminar) {
                ignoreRouterFreeLogin.push('/seminars');
            } else {
                ignoreRouterFreeLogin.push('/list-seminar');
            }
            temp = temp.filter((route) => !ignoreRouterFreeLogin.includes(route.path));
        }

        if (isWeakAuth === '' && isAuthorized) {
            const routeLoginAcc = [
                '/list-seminar',
            ];
            if (eventInfo.free_live_stream) {
                routeLoginAcc.push('/live-stream-registered');
            }
            if (eventInfo.free_seminar) {
                routeLoginAcc.push('/seminar_registered');
            }
            if (eventInfo.free_exhibition) {
                routeLoginAcc.push('/exhibitor-posters');
            }
            temp = temp.filter((route) => !routeLoginAcc.includes(route.path));
        }

        if (+viewerType !== 3 && isWeakAuth === '') {
            if (+viewerType !== 1) {
                const exhibitionRoutes = [
                    '/exhibitor-posters',
                    '/exhibitors',
                ];
                temp = temp.filter((route) => !exhibitionRoutes.includes(route.path));
            }
            if (+viewerType !== 2) {
                const seminarRoutes = [
                    '/seminars',
                    '/seminar_registered',
                ];
                temp = temp.filter((route) => !seminarRoutes.includes(route.path));
            }
        }

        if ((!viewerLiveStream || viewerLiveStream === 'false') && isWeakAuth === '') {
            const liveStreamRoutes = [
                '/live_stream',
                '/live-stream-registered',
            ];
            temp = temp.filter((route) => !liveStreamRoutes.includes(route.path));
        }

        if (!(eventInfo.has_shopping_cart && eventInfo.grand_zone && !eventInfo.free_exhibition
            && isWeakAuth === '' && isAuthorized && (+viewerType === 1 || +viewerType === 3))) {
            const shoppingCart = [
                '/shopping-cart',
            ];
            temp = temp.filter((route) => !shoppingCart.includes(route.path));
        }

        setListRoutes(temp);
    }, [eventInfo, isAuthorized, routes, isWeakAuth, viewerLiveStream, viewerType, loginOuterServer]);

    useEffect(() => {
        if (_.isEmpty(dataAuthorized)) fetchClearGetDetailCompanyOrganizerForSideBar();
        else if (isAuthorized && !_.isEmpty(dataAuthorized)) getDetailCompanyForSideBar();
        if (isAuthorized && !_.isEmpty(dataAuthorized) && isWeakAuth === '') getCount();
    }, [dataAuthorized, fetchClearGetDetailCompanyOrganizerForSideBar, getDetailCompanyForSideBar, params.shortName, isAuthorized]);

    useEffect(() => {
        if (!_.isEmpty(countProduct)) {
            setCountCart(+countProduct?.product_number);
        }
    }, [countProduct]);

    useEffect(() => {
        if (history.location.pathname && params.shortName) {
            const textTypeRoute = routes.find((item) => {
                if (history.location.pathname.includes(item.path)) return item;
                return null;
            });
            fetchInfo({ shortName: params.shortName, language: locale });
            if (!_.isEmpty(textTypeRoute) && !_.isUndefined(textTypeRoute.text_type)) {
                getCustomText({
                    eventShortName: params.shortName,
                    site: 0,
                    text_type: textTypeRoute.text_type,
                    language: locale,
                });
            }
        }
    }, [params.shortName, history.location.pathname, locale]);

    useEffect(() => {
        if (location.pathname === `/${params.shortName}/exhibitor_login`) {
            setColorOrganizer(true);
        } else setColorOrganizer(false);
    }, [location.pathname]);

    useEffect(() => {
        const selectedLanguage = sessionStorage.getItem('selectedLang');
        if (selectedLanguage && selectedLanguage !== '日本語') {
            handleSelectLanguage('en', selectedLanguage, true, false);
        }
    }, [isAuthorized, isWeakAuth]);

    useEffect(() => {
        const w = window.innerWidth;
        if (w < 960) {
            setScreenSize(true);
        } else {
            setScreenSize(false);
        }
        window.addEventListener('resize', handleResize);
        return () => { window.removeEventListener('resize', handleResize); };
    }, []);
    
    /*  ★★ */
   // console.log( customTimerctrl )

    useEffect(() =>{
    	getSettingCustomTimerctrl({eventShortName: params.shortName});
    	return () =>{
            clearGetSettingCustomTimerctrl();
    	}
    },[] );
  
    
    const handleLogOutSystem = () => {
        setIsOpenEndDialog(true);
    };

    const handleBackHomePage = () => {
        history.push(`/${params.shortName}/home`);
    };
    const handleChange = (intersection) => {
        if (intersection) {
            setClassFixed('');
        } else {
            setClassFixed('fixedSidebar');
        }
    };
    const handleClose = () => {
        if (logOut) {
            if (eventInfo.done_language_config) {
                const focusLanguage = sessionStorage.getItem('selectedLang');
                if (focusLanguage !== '日本語' && focusLanguage !== 'English') {
                    sessionStorage.setItem('selectedLang', 'English');
                }
            }
            logOut();
            cookies.remove('tabSelect', { path: '/' });
            setIsOpenEndDialog(false);
            history.push(`/${params.shortName}/home`);
            clearCount();
            if (eventInfo.done_language_config) {
                changeLangInit();
            }
        }
    };
    const handleCloseDialog = () => {
        setIsOpenEndDialog(false);
    };

    const handleRedirectSurvey = () => {
        window.open(locale === 'en' ? eventInfo.survey_link_viewer_en : eventInfo.survey_link_viewer, '_blank');
    };

    const options = {
        threshold: 1,
        rootMargin: '0px',
        onChange: handleChange,
    };

    const routerCheckTime = [
        '/exhibitors',
        '/exhibitor-posters',
    ];

    const renderSurveyLink = (isMobileMode) => {
        if (!isAuthorized || !isUser) return null;

        if (_.toNumber(role) === Role.viewer && !(locale === 'en' ? eventInfo.survey_link_viewer_en : eventInfo.survey_link_viewer)) return null;

        return (
            <div className={classes.item}>
                <ListItem
                    button
                    onClick={() => {
                        if (isMobileMode) {
                            handleDrawerToggle();
                        }
                        
                        handleRedirectSurvey();
                    }}
                    className={!(eventInfo.layout_sidebar && (+role !== Role.organizer))
                        ? classes.itemLink
                        : classes.itemLinkCustomLayoutMobile}
                >
                    <SurveyIcon
                        color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                    />
                    <ListItemText
                        primary={eventInfo?.settings_texts_sidebar_viewer?.field_name?.survey || intl.formatMessage({ id: 'userRouters.survey' })}
                        className={classes.visitorText}
                        disableTypography
                    />
                </ListItem>
            </div>
        );
    };

    const namePageCart = (name) => (
        <div style={{ display: 'flex' }}>
            <span className={!eventInfo.layout_sidebar ? '' : classes.visitorTextLogoutLayoutCustomCart}>{name}</span>
            {
                +countCart !== 0 && (
                    <span className={+countCart < 10 ? classes.countNumber : classes.countPlus}>
                        {+countCart < 10 ? +countCart : '+'}
                    </span>
                )
            }
        </div>
    );

    const setLanguageSession = (content) => {
        setLanguage(content);
        sessionStorage.setItem('selectedLang', content);
    };

    const handleSelectLanguage = (lang, titleContent, isChangeLanguage, update) => {
        const googleIframe = document.getElementById(':1.container')?.contentWindow.document.getElementById(':1.close');
        const googleSelect = document.querySelector('.goog-te-combo');
        if (googleIframe && isChangeLanguage) {
            googleIframe.click();
        }
        setLanguageSession(titleContent);
        setIsOpenTranslate(false);
        if (lang === 'en') {
            sessionStorage.setItem('valueLang', 'en');
            const existedScript = document.getElementById('google-trans');
            if (existedScript === null) {
                const addScript = document.createElement('script');
                addScript.setAttribute(
                    'src',
                    '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
                );
                addScript.setAttribute(
                    'id',
                    'google-trans',
                );
                document.body.appendChild(addScript);
                window.googleTranslateElementInit = googleTranslateElementInit;
            } else if (googleSelect) {
                googleSelect.style.display = 'block';
                // if (langChange !== 'en' && langChange !== 'ja') window.location.reload();
            }
            changeLangOther(sessionStorage.getItem('selectedLang'));
            setIsGoogleTrans(true);
            changeLanguage(lang);
        } else {
            sessionStorage.setItem('valueLang', 'ja');
            if (googleSelect) {
                googleSelect.style.display = 'none';
                if (langChange !== 'en' && langChange !== 'ja') window.location.reload();
            }
            changeLangOther(sessionStorage.getItem('selectedLang'));
            setIsGoogleTrans(false);
            changeLanguage(lang);
        }
        if (isWeakAuth === '' && isAuthorized && update) {
            updateLanguage(lang);
        }
    };

    const googleTranslateElementInit = () => {
        setTimeout(() => {
            window.google.translate.TranslateElement(
                { pageLanguage: 'en', includedLanguages: sessionStorage.getItem('objLang') },
                'google_translate_element',
            );
            const googleSelect = document.querySelector('.goog-te-combo');
            if (googleSelect) {
                googleSelect.addEventListener('change', () => {
                    setIsOpenTranslate(false);
                    changeLangOther(googleSelect.options[googleSelect.selectedIndex].text);
                    setLanguageSession(googleSelect.options[googleSelect.selectedIndex].text);
                    updateLanguage(googleSelect.options[googleSelect.selectedIndex].value);
                });
            }
        }, 1000);
    };

    const renderTranslate = (isMobileMode) => (
        <div className={classes.item}>
            <ListItem
                button
                className={!(eventInfo.layout_sidebar && (+role !== Role.organizer)) ? classes.itemTranslate : classNames(classes.itemLinkCustomLayoutMobile, classes.nextMobile)}
                onClick={() => setIsOpenTranslate((prev) => !prev)}
            >
                <LanguageIcon
                    color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                />
                <ListItemText
                    primary={language}
                    className={classNames(!colorOrganizer ? classes.visitorText : classes.itemText)}
                />
                {isOpenTranslate
                    ? <ArrowDown className={!colorOrganizer ? classes.visitorText : classes.itemText} />
                    : <NextIcon className={!colorOrganizer ? classes.visitorText : classes.itemText} />}
            </ListItem>
            <ul className={isOpenTranslate ? classNames(!isMobileMode ? classes.translateOpen : classes.translateOpenMobile) : classes.translateClose}>
                <ListItem button onClick={() => handleSelectLanguage('ja', '日本語', true, true)} className={isMobileMode ? classes.mainItemTranslateMobile : classes.mainItemTranslate}>
                    <ListItemText
                        primary="日本語"
                        className={classNames(!colorOrganizer ? classes.visitorText : classes.itemText)}
                        disableTypography
                    />
                </ListItem>
                <ListItem button onClick={() => handleSelectLanguage('en', 'English', true, true)} className={isMobileMode ? classes.mainItemTranslateMobile : classes.mainItemTranslate}>
                    <ListItemText
                        // eslint-disable-next-line no-nested-ternary
                        primary={!showGoogle ? 'English' : (isGoogleTrans ? 'English' : 'English/Other Language')}
                        className={classNames(!colorOrganizer ? classes.visitorTextOther : classes.itemText)}
                    />
                </ListItem>
                {showGoogle && <ListItem id="google_translate_element" className={!isMobileMode ? classes.test : classes.googleMobile} />}
            </ul>
        </div>
    );
    
    const links = (isMobileMode) => (
        <List className={classes.list}>
            {
                listRoutes.map((prop) => {
                    if (prop.path === '/exhibitor-posters' && (!isAuthorized || isAfterEnd30Day(eventInfo.edate))) {
                        return '';
                    }
                    if ((prop.path === '/seminar_registered' || prop.path === '/seminars') && (!isAuthorized)) {
                        return '';
                    }

                    if( prop.path === '/list-seminar'  && JMB_TC_smn_before  ){   
                        // セミナーリストで開始日からの表示期間切り替えがればJMB_TC_smn_beforeで適用
                        //console.log( "L554  JMB_TC_smn_before check start....");
                        if( prop.path === '/list-seminar'  && isBeforeUsingStartXdays(eventInfo.sdate,JMB_TC_smn_before)) {
                        //  console.log( "L556  smn_before executed....");
                        //  console.log( " JMB_TC_smn_before = " + JMB_TC_smn_before ); 
                          return '';
                        } 
                    }
                    if( prop.path === '/list-seminar'  && JMB_TC_smn_after ){
                        // セミナーリストで展示会終了日から表示期間指定があれば JMB_TC_smn_afterで適用 
                        //  console.log( "L563 check JMB_TC_smn_after .JMB_TC_smn_after=" + JMB_TC_smn_after +" , edate=" + eventInfo.edate ) ;
                          if ( prop.path === '/list-seminar'  && isAfterUsingEndXdays(eventInfo.edate, JMB_TC_smn_after)) {
                            //  console.log( "L565 isAfterUsinEndXdays Hitted ." ) ;
                            //  console.log( "JMB_TC_smn_after  = " + JMB_TC_smn_after );
                              return '';
                          } 
                    }
                   
                    if( routerCheckTime.includes(prop.path) && JMB_TC_exhlist_before  ){   
                      /* customで出展一覧で開始日からの表示期間切り替えがればcustomTimerctrl.TC_exhlist_beforeで適用 */
                      // console.log( "L558  exhlist_before check start....");
                      if( routerCheckTime.includes(prop.path) &&  isBeforeUsingStartXdays(eventInfo.sdate,JMB_TC_exhlist_before)) {
                        //console.log( "L560  exhlist_before executed....");
                        //console.log( " JMB_TC_exhlist_before = " + JMB_TC_exhlist_before ); 
                        return '';
                      } 
                    }else{
                      /* customTimerctrl.TC_exhlist_beforeが存在しなければ出展一覧で開始日からの表示期間切り替えは14日で固定 */
                        if ( routerCheckTime.includes(prop.path) &&  isBeforeUsingStartXdays(eventInfo.sdate,14) ){
                           return '';
                        }
                    }
                    if( routerCheckTime.includes(prop.path) && JMB_TC_exhprod_after ){
                      /* customで出展一覧で終了日から表示期間指定があれば JMB_TC_exhprod_afterで適用 */
                        console.log( "L572 check exhprod_after .JMB_TC_exhprod_after=" + JMB_TC_exhprod_after +" , edate=" + eventInfo.edate ) ;
                        if ( routerCheckTime.includes(prop.path) && isAfterUsingEndXdays(eventInfo.edate, JMB_TC_exhprod_after)) {
                        //    console.log( "L574 isAfterUsinEndXdays Hitted ." ) ;
                        //    console.log( "JMB_TC_exhprod_after  = " + JMB_TC_exhprod_after );
                            return '';
                        } 
                    }else{
                      /* customTimerctrl.TC_exhprod_after存在しなければ出展一覧は終了日から30日固定で切り替え */
                        if (  routerCheckTime.includes(prop.path) &&  isAfterUsingEndXdays(eventInfo.edate,2) ){
                            
                           return '';
                        }
                    }
    
                    const listItemClasses = classNames({
                        [` ${classes[color]}`]: activeRoute(`${prop.param}${prop.path}`),
                    });
                    const whiteFontClasses = classNames({
                        [`${classes.whiteFont}`]: activeRoute(`${prop.param}${prop.path}`),
                    });
                    return (
                        <NavLink
                            to={`/${params.shortName}${prop.path}`}
                            text={prop?.isCheckCount ? namePageCart(prop.name) : prop.name}
                            className={classes.item}
                            activeClassName="active"
                            exact
                            isActive={prop.isActiveFunc}
                            key={prop.path}
                            onClick={()=>{
                                if( isMobileMode ){ 
                                    handleDrawerToggle() ;
                                }
                                const regexpcc1= /\/exhibitors/;
                                console.log("CK_L621");
                                console.log(  window.location.pathname  );
                                if( regexpcc1.test( window.location.pathname ) ){
                                    console.log( "CLEAR search L628 usersidebar");
                                    console.log( window.location.pathname);
                                    window.location.reload();
                                    //handleSearchDataClear();
                                }
                            }}
                        >
                            <ListItem
                                button
                                className={!(eventInfo.layout_sidebar && (+role !== Role.organizer))
                                    ? classes.itemLink + listItemClasses
                                    : classes.itemLinkCustomLayoutMobile + listItemClasses}
                            >
                                <prop.icon
                                    color={activeRoute(`${prop.param}${prop.path}`)
                                        ? (customColorSidebar?.sidebar_icon?.selected || '#fff')
                                        : customColorSidebar?.sidebar_icon?.other || '#fff'}
                                />
                                <ListItemText
                                    primary={prop?.isCheckCount
                                        ? namePageCart(eventInfo?.settings_texts_sidebar_viewer?.field_name?.[prop.customName] || prop.name)
                                        : (eventInfo?.settings_texts_sidebar_viewer?.field_name?.[prop.customName] || prop.name)}
                                    className={classNames(!colorOrganizer ? classes.visitorText : classes.itemText, whiteFontClasses)}
                                    disableTypography
                                />
                            </ListItem>
                        </NavLink>
                    );
                })
            }
            {renderSurveyLink(isMobileMode)}
            {!_.isEmpty(eventInfo.languages) && eventInfo?.done_language_config && renderTranslate(isMobileMode)}
            {isAuthorized && isUser && Number(role) !== Role.admin && (
                <div className={classes.logOutButton}>
                    <ListItem
                        button
                        className={!(eventInfo.layout_sidebar && (+role !== Role.organizer))
                            ? `${classes.itemLink} ${classes.orange}`
                            : `${classes.itemLinkCustomLayoutMobile} ${classes.orange}`}
                        onClick={() => {
                            if (isMobileMode) {
                                handleDrawerToggle();
                            }
                            handleLogOutSystem();
                        }}
                    >
                        <LogOutIcon
                            color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                        />
                        <ListItemText
                            primary={eventInfo?.settings_texts_sidebar_viewer?.field_name?.logout || <FormattedMessage id="logout" />}
                            className={classes.visitorTextLogout}
                            disableTypography
                        />
                    </ListItem>
                </div>
            )}
        </List>
    );

    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <>
                    <FormDialog
                        isOpen={isOpenEndDialog}
                        handleClose={handleCloseDialog}
                    >
                        <GridContainer style={{ marginTop: '60px' }} justify="center">
                            <GridItem>
                                <Typography style={{ textAlign: 'center' }} bold variant="h5" color="navy" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                    {eventInfo.name}
                                    {' '}
                                    {intl.formatMessage({ id: 'home.exhibition' })}
                                </Typography>
                            </GridItem>
                            <GridItem>
                                <Typography style={{ textAlign: 'center' }} bold variant="h5" color="navy" customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                                    {intl.formatMessage({ id: 'home.noteThanksViewer' })}
                                </Typography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer style={{ marginTop: '60px' }} justify="center">
                            <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                <Button
                                    onClick={handleClose}
                                    color="navy"
                                    size="md"
                                    className={classes.buttonBig}
                                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.common_button}
                                >
                                    {intl.formatMessage({ id: 'common.end' })}
                                </Button>
                            </Box>
                        </GridContainer>
                        {
                            eventInfo.display_ads && (
                                <GridContainer style={{ marginTop: '60px' }} justify="center">
                                    <Advertisement
                                        customColor={eventInfo?.settings_colors_viewer}
                                    />
                                </GridContainer>
                            )
                        }
                    </FormDialog>
                    {!(eventInfo.layout_sidebar && (+role !== Role.organizer)) ? (
                        <>
                            {screenSize
                                ? (
                                    <Hidden implementation="css">
                                        <Drawer
                                            variant="temporary"
                                            anchor="right"
                                            open={isOpenToggle}
                                            classes={{
                                                paper: classNames(classes.drawerPaper),
                                            }}
                                            onClose={handleDrawerToggle}
                                            ModalProps={{
                                                keepMounted: true,
                                            }}
                                        >
                                            <div className={classes.logo}>
                                                <Typography
                                                    variant="h4"
                                                    color="white"
                                                    bold
                                                    onClick={() => {
                                                        handleBackHomePage();
                                                    }}
                                                    className={classes.brand}
                                                >
                                                    XPAND
                                                </Typography>
                                            </div>
                                            <div className={classes.sidebarWrapper}>
                                                {links(true)}
                                            </div>
                                            <div
                                                className={!colorOrganizer ? classes.visitorBackGround : classes.background}
                                                style={{ backgroundImage: `url(${image})` }}
                                            />
                                        </Drawer>
                                    </Hidden>
                                ) : (
                                    <Hidden implementation="css">
                                        <Observer {...options} />
                                        <Drawer
                                            anchor="left"
                                            variant="permanent"
                                            open
                                            classes={{
                                                paper: classNames(classes.drawerPaper, classes[classFixed]),
                                                docked: classNames(classes.docked),
                                            }}
                                        >
                                            <div className={classNames(classes.sidebarWrapper)}>
                                                {links(false)}
                                            </div>
                                            <div
                                                className={!colorOrganizer ? classes.visitorBackGround : classes.background}
                                                style={{ backgroundImage: `url(${image})` }}
                                            />
                                        </Drawer>
                                    </Hidden>
                                )}
                        </>
                    ) : (
                        <>
                            <UserSideBarCustomLayoutFirst
                                params={params}
                                customColorSidebar={customColorSidebar}
                                listRoutes={listRoutes}
                                eventInfo={eventInfo}
                                isAuthorized={isAuthorized}
/*                                isAfterEnd30Day={isAfterEnd30Day(eventInfo.edate)}        */
/*                                isBeforeStart14Day={isBeforeStart14Day(eventInfo.sdate)}  */
                                isBeforeUsingStartXdays={isBeforeUsingStartXdays(eventInfo.sdate,(
                                	 (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhlist_before") )
                                	 ? customTimerctrl.TC_exhlist_before
                                	     :  14  )   )}

                                isAfterUsingEndXdays={isAfterUsingEndXdays(eventInfo.edate,(
                                	 (customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") )
                                	 ? customTimerctrl.TC_exhprod_after
                                	     :  30  )   )}

                                namePageCart={(name) => namePageCart(name)}
                                activeRoute={(router) => activeRoute(router)}
                                routerCheckTime={routerCheckTime}
                                handleDrawerToggle={() => handleDrawerToggle()}
                                color={color}
                                routerActive={cookies.get('tabSelect') || 0}
                                isUser={isUser}
                                role={role}
                                handleRedirectSurvey={() => handleRedirectSurvey()}
                                handleLogOutSystem={() => handleLogOutSystem()}
                                handleBackHomePage={() => handleBackHomePage()}
                                isOpenToggle={isOpenToggle}
                                options={options}
                                classFixed={classFixed}
                                sidebarMobile={links(true)}
                                handleSelectLanguage={(nameLang, textLang, changeLang, isUpdate) => handleSelectLanguage(nameLang, textLang, changeLang, isUpdate)}
                                isGoogleTrans={isGoogleTrans}
                                language={language}
                                isOpenTranslate={isOpenTranslate}
                                setIsOpenTranslate={(value) => setIsOpenTranslate(value)}
                            />
                        </>
                    )}
                </>
            )}
        </>
    );
};

UserSideBar.defaultProps = {
    color: 'blue',
    role: 0,
    isAuthorized: false,
    isUser: false,
    isOpenToggle: false,
    image: '',
    routes: {},
    eventInfo: {},
    userData: {},
    freeType: undefined,
    hasLiveStream: false,
    freeSeminar: false || undefined,
    freeExhibition: false || undefined,
    freeLiveStream: false || undefined,
    viewerType: false || undefined,
    viewerLiveStream: false || undefined,
    eventCurrent: '',
    dataAuthorized: {},
    getCount: () => {},
    clearCount: () => {},
    countProduct: {},
    loginOuterServer: {},
    getCustomText: () => {},
    customColorSidebar: {},
    changeLanguage: () => {},
    updateLanguage: () => {},
    locale: '',
    fetchInfo: () => {},
    language: {},
    langChange: '',
    changeLangOther: () => {},
    changeLangInit: () => {},

/* ★★ */
    getSettingCustomTimerctrl: () =>{},
    customTimerctrl: {},
    clearGetSettingCustomTimerctrl: () =>{},

};

UserSideBar.propTypes = {
    color: PropTypes.string,
    role: PropTypes.number,
    image: PropTypes.string,
    routes: PropTypes.oneOfType([() => null, PropTypes.array]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    userData: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
    isOpenToggle: PropTypes.bool,
    isUser: PropTypes.bool,
    logOut: PropTypes.func.isRequired,
    handleDrawerToggle: PropTypes.func.isRequired,
    freeType: PropTypes.number,
    hasLiveStream: PropTypes.bool,
    organizerLiveStream: PropTypes.bool.isRequired,
    organizerType: PropTypes.string.isRequired,
    freeSeminar: PropTypes.oneOfType([() => null, PropTypes.bool || PropTypes.string]),
    freeExhibition: PropTypes.oneOfType([() => null, PropTypes.bool || PropTypes.string]),
    freeLiveStream: PropTypes.oneOfType([() => null, PropTypes.bool || PropTypes.string]),
    viewerType: PropTypes.oneOfType([() => null, PropTypes.bool || PropTypes.string]),
    viewerLiveStream: PropTypes.oneOfType([() => null, PropTypes.bool || PropTypes.string]),
    eventCurrent: PropTypes.string,
    fetchClearGetDetailCompanyOrganizerForSideBar: PropTypes.func.isRequired,
    dataAuthorized: PropTypes.oneOfType([() => null, PropTypes.object]),
    getDetailCompanyForSideBar: PropTypes.func.isRequired,
    getCount: PropTypes.func,
    clearCount: PropTypes.func,
    countProduct: PropTypes.oneOfType([() => null, PropTypes.object]),
    loginOuterServer: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCustomText: PropTypes.func,
/*  ★★　*/ 
    getSettingCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearGetSettingCustomTimerctrl: PropTypes.func,

    customColorSidebar: PropTypes.oneOfType([() => null, PropTypes.object]),
    changeLanguage: PropTypes.func,
    updateLanguage: PropTypes.func,
    locale: PropTypes.string,
    fetchInfo: PropTypes.func,
    language: PropTypes.oneOfType([() => null, PropTypes.object]),
    langChange: PropTypes.string,
    changeLangOther: PropTypes.func,
    changeLangInit: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    logOut: () => {
        dispatch(LogoutRequested());
    },
    fetchClearGetDetailCompanyOrganizerForSideBar: () => {
        dispatch(ClearGetDetailCompanyOrganizerForSideBar());
    },
    getDetailCompanyForSideBar: () => {
        dispatch(GetDetailCompanyOrganizerForSideBarRequested());
    },
    getCount: () => {
        dispatch(getCountProductRequested());
    },
    clearCount: () => {
        dispatch(clearCountProduct());
    },
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },

    changeLanguage: (param) => {
        dispatch(changeLanguageActions(param));
    },
    updateLanguageUser: (param) => {
        dispatch(updateLanguageRequest(param));
    },
    fetchInfo: (event) => {
        dispatch(callApiGetInformationXPAND(event));
    },
    clearInfo: () => {
        dispatch(clearGetInfomationData());
    },
    changeLangOther: (param) => {
        dispatch(changeLanguageOtherActions(param));
    },
    changeLangInit: () => {
        dispatch(changeLanguageOtherInit());
    },


});
const mapStateToProps = (state) => ({
    eventInfo: state.registrationOrganizer.registrationOrganizer.data,
    isAuthorized: state.auth.credential.isAuthorized,
    isWeakAuth: state.auth.credential.data?.isWeakAuth,
    dataAuthorized: state.auth.credential.data,
    freeType: state.auth.credential.data?.freeType,
    viewerType: state.auth.credential.data?.viewer_type,
    viewerLiveStream: state.auth.credential.data?.viewer_live_stream,
    role: state.auth.credential.data.role,
    userData: state.auth.credential.data,
    hasLiveStream: state.auth.credential.data.hasLiveStream !== 'false',
    organizerType: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_type,
    organizerLiveStream: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_live_stream,
    freeSeminar: state.auth.credential.data?.freeSeminar,
    freeLiveStream: state.auth.credential.data?.freeLiveStream,
    freeExhibition: state.auth.credential.data?.freeExhibition,
    eventCurrent: state.auth.credential.data?.event,
    organizerBooth: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_booth,
    countProduct: state.cartViewer.count.data,
    loginOuterServer: state.home.loginOuterServer.data,
    locale: state.locale.lang.current,
    langChange: state.locale.changeLanguage.lang,
  
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    updateLanguage: (param) => {
        // if (stateProps.isAuthorized && stateProps.isWeakAuth === '') {
        dispatchProps.updateLanguageUser(param);
        // }
    },
});
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
)(UserSideBar);
